import React from 'react';

const Divider = ({ className, id }) => {
  return <hr className={`border-gray-100 my-2 ${className}`} id={id} />;
};

export default Divider;
